import React, { useState } from "react";

import {
  Button,
  Menu,
  MenuItem,
  Skeleton,
  Tooltip,
  Typography
} from "@mui/material";
import { Trans, useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import BarChartIcon from "@mui/icons-material/BarChart";

import useStyles from "../Header.styles";
import { betLimitTranslation, betTranslation } from "../../../utils/constants";
import { getBetLimitStart } from "../../../redux-saga/redux/profile/myProfile";

const BetLimit = () => {
  const classes = useStyles();
  const [anchorElAccount, setAnchorElAccount] = useState(null);
  const { betLimit, betLimitLoading } = useSelector((state) => state.myProfile);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const openLimit = Boolean(anchorElAccount);

  const handleOpenLimit = (event) => {
    dispatch(getBetLimitStart());
    setAnchorElAccount(event.currentTarget);
  };
  const handleCloseLimit = () => {
    setAnchorElAccount(null);
  };

  return (
    <>
      <Tooltip
        arrow
        classes={{
          tooltip: classes.toolTipWrap,
          arrow: classes.toolTipArrow
        }}
        className={classes.toolTipWrap}
        title={t("HEADER.BET_LIMITS")}
        placement="bottom"
      >
        <Button
          id="account-button"
          className={`${classes.btnPrimary} ${classes.btnbetLimit}`}
          aria-controls={openLimit ? "betLimit-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={openLimit ? "true" : undefined}
          onClick={handleOpenLimit}
        >
          <BarChartIcon />
        </Button>
      </Tooltip>

      <Menu
        id="account-menu"
        anchorEl={anchorElAccount}
        open={openLimit}
        className={classes.betLimitMenu}
        onClose={handleCloseLimit}
        MenuListProps={{
          "aria-labelledby": "account-button"
        }}
      >
        {!!betLimit?.length && (
          <Typography variant="h7" className={classes.maxBetLimit}>
            {t("HEADER.MAXIMUM_BET_LIMITS")}
          </Typography>
        )}
        {betLimit?.map((item, index) => (
          <div key={index}>
            {Object.keys(item).map((key) => (
              <MenuItem key={key} onClick={handleCloseLimit}>
                <div className={classes.translationWrapper}>
                  <span>{t(betLimitTranslation[key])} </span>

                  <span>
                    {item[key]}
                    <span className={classes.betTranslation}>
                      {t(betTranslation[key])}
                    </span>
                  </span>
                </div>
              </MenuItem>
            ))}
          </div>
        ))}
        {!!betLimit?.length && (
          <Typography className={classes.betLimitExceed} variant="h7">
            <Trans components={{ br: <br /> }}>
              {t("HEADER.BET_LIMIT_EXCEED")}
            </Trans>
          </Typography>
        )}

        {betLimitLoading &&
          Array.from({ length: 5 }).map((data, i) => {
            return <Skeleton key={i} width={"200px"} />;
          })}
      </Menu>
    </>
  );
};

export default BetLimit;
